import * as React from 'react';

export default function useElementSize(targetRef: React.RefObject<HTMLElement>) {
  const [width, setWidth] = React.useState(105);
  const [height, setHeight] = React.useState(105);

  React.useEffect(() => {
    const resizeObserver = new ResizeObserver((event) => {
      // https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserverEntry/contentBoxSize
      setWidth(event[0].contentBoxSize[0].inlineSize);
      setHeight(event[0].contentBoxSize[0].blockSize);
    });

    if (targetRef.current) {
      resizeObserver.observe(targetRef.current);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, [targetRef]);

  return {
    width,
    height,
  };
}
